/**
 * 服务器发送事件（SSE）上下文管理
 *
 * 这个文件负责管理服务器发送事件相关的状态，包括：
 * - SSE 数据管理
 * - 构建状态管理
 * - 实时数据更新处理
 */

/* eslint-disable */
// @ts-nocheck no change，Ignore ts check
import { createContext, useCallback, useContext, useState } from 'react'

/**
 * SSE 上下文的初始值
 */
const initialValue = {
  updateSSEData: () => {},
  sseData: {},
  isBuilding: false,
  setIsBuilding: (isBuilding: boolean) => {}
}

// 创建 SSE 上下文
const SSEContext = createContext(initialValue)

/**
 * 使用 SSE 上下文的 Hook
 * @returns SSE 上下文的值
 */
export function useSSE() {
  return useContext(SSEContext)
}

/**
 * SSE 提供者组件
 *
 * @param children - 子组件
 * @returns 提供 SSE 相关状态和方法的上下文提供者
 */
export function SSEProvider({ children }) {
  const [sseData, setSSEData] = useState({})
  const [isBuilding, setIsBuilding] = useState(false)

  /**
   * 更新 SSE 数据
   * @param newData - 新的数据对象
   */
  const updateSSEData = useCallback((newData: any) => {
    setSSEData(prevData => ({
      ...prevData,
      ...newData
    }))
  }, [])

  return (
    <SSEContext.Provider value={{ sseData, updateSSEData, isBuilding, setIsBuilding }}>{children}</SSEContext.Provider>
  )
}
